import React from "react";
import { Card, Typography, CardMedia } from "@mui/material";

const CustomImageCard = ({ image, name, onClick }) => {
  return (
    <Card
      sx={{
        maxWidth: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        border: "1px solid #A5A5A5",
        padding: "20px",
        marginBottom: "10px",
      }}
      onClick={onClick}
    >
      <CardMedia
        component="img"
        sx={{
          width: "55%",
          height: 40,
          //   objectFit: "stretch",
          //   padding: "10px 0px",
        }}
        image={image}
        alt={name}
      />
      <div>
        <Typography variant="subtitle1">{name}</Typography>
      </div>
    </Card>
  );
};

export default CustomImageCard;
